export const DJISymbols = [
  'MMM',
  'AXP',
  'AMGN',
  'AAPL',
  'BA',
  'CAT',
  'CVX',
  'CSCO',
  'KO',
  'DOW',
  'GS',
  'HD',
  'HON',
  'IBM',
  'INTC',
  'JNJ',
  'JPM',
  'MCD',
  'MRK',
  'MSFT',
  'NKE',
  'PG',
  'CRM',
  'TRV',
  'UNH',
  'VZ',
  'V',
  'WMT',
  'WBA',
  'DIS',
  'SPY',
];

export const NASDAQSymbols = [
  'AAPL',
  'MSFT',
  'AMZN',
  'FB',
  'GOOGL',
  'GOOG',
  'TSLA',
  'NVDA',
  'PYPL',
  'ADBE',
  'NFLX',
  'CMCSA',
  'CSCO',
  'INTC',
  'PEP',
  'AVGO',
  'COST',
  'AMGN',
  'TXN',
  'CHTR',
  'QCOM',
  'SBUX',
  'GILD',
  'AMAT',
  'TMUS',
  'MDLZ',
  'ISRG',
  'INTU',
  'BKNG',
  'FISV',
  'ADP',
  'MU',
  'BIDU',
  'KHC',
  'ILMN',
  'LRCX',
  'MAR',
  'MELI',
  'ADSK',
  'ATVI',
  'CSX',
  'MNST',
  'MCHP',
  'MDT',
  'REGN',
  'ROST',
  'SIRI',
  'SPLK',
  'WDAY',
  'ZM',
  'ZBRA',
  'CTSH',
  'EXC',
  'PCAR',
  'VRTX',
  'WBA',
  'ALGN',
  'ALXN',
  'ASML',
  'BIIB',
  'CDNS',
  'CDW',
  'CHKP',
  'CTAS',
  'CTXS',
  'EA',
  'EXPE',
  'FAST',
  'FOX',
  'FOXA',
  'IDXX',
  'KLAC',
  'LULU',
  'MXIM',
  'NTAP',
  'NTES',
  'NXPI',
  'ORLY',
  'PAYX',
  'PYPL',
  'QCOM',
  'REGN',
  'ROST',
  'SBUX',
  'SNPS',
  'SWKS',
  'TCOM',
  'ULTA',
  'VRSK',
  'VRSN',
  'VRTX',
  'WBA',
  'WDC',
  'WLTW',
  'XEL',
  'XLNX',
  'XRAY',
];

export const SP500Symbols = [
  'MMM',
  'ABT',
  'ABBV',
  'ABMD',
  'ACN',
  'ATVI',
  'ADBE',
  'AMD',
  'AAP',
  'AES',
  'AFL',
  'A',
  'APD',
  'AKAM',
  'ALK',
  'ALB',
  'ARE',
  'ALXN',
  'ALGN',
  'ALLE',
  'LNT',
  'ALL',
  'GOOGL',
  'GOOG',
  'MO',
  'AMZN',
  'AMCR',
  'AEE',
  'AAL',
  'AEP',
  'AXP',
  'AIG',
  'AMT',
  'AWK',
  'AMP',
  'ABC',
  'AME',
  'AMGN',
  'APH',
  'ADI',
  'ANSS',
  'ANTM',
  'AON',
  'AOS',
  'APA',
  'AIV',
  'AAPL',
  'AMAT',
  'APTV',
  'ADM',
  'ANET',
  'AJG',
  'AIZ',
  'T',
  'ATO',
  'ADSK',
  'ADP',
  'AZO',
  'AVB',
  'AVY',
  'BKR',
  'BLL',
  'BAC',
  'BK',
  'BAX',
  'BDX',
  'BRK.B',
  'BBY',
  'BIIB',
  'BLK',
  'BA',
  'BKNG',
  'BWA',
  'BXP',
  'BSX',
  'BMY',
  'AVGO',
  'BR',
  'BF.B',
  'CHRW',
  'COG',
  'CDNS',
  'CPB',
  'COF',
  'CAH',
  'KMX',
  'CCL',
  'CARR',
  'CTLT',
  'CAT',
  'CBOE',
  'CBRE',
  'CDW',
  'CE',
  'CNC',
  'CNP',
  'CERN',
  'CF',
  'SCHW',
  'CHTR',
  'CVX',
  'CMG',
  'CB',
  'CHD',
  'CI',
  'XEC',
  'CINF',
  'CTAS',
  'CSCO',
  'C',
  'CFG',
  'CTXS',
  'CLX',
  'CME',
  'CMS',
  'KO',
  'CTSH',
  'CL',
  'CMCSA',
  'CMA',
  'CAG',
  'CXO',
  'COP',
  'ED',
  'STZ',
  'COO',
  'CPRT',
  'GLW',
  'CTVA',
  'COST',
  'COTY',
  'CCI',
  'CSX',
  'CMI',
  'CVS',
  'DHI',
  'DHR',
  'DRI',
  'DVA',
  'DE',
  'DAL',
  'XRAY',
  'DVN',
  'FANG',
  'DLR',
  'DFS',
  'DISCA',
  'DISCK',
  'DISH',
  'DG',
  'DLTR',
  'D',
  'DPZ',
  'DOV',
  'DOW',
  'DTE',
  'DUK',
  'DRE',
  'DD',
  'DXC',
  'ETFC',
  'EMN',
  'ETN',
  'EBAY',
  'ECL',
  'EIX',
  'EW',
  'EA',
  'EMR',
  'ETR',
  'EOG',
  'EFX',
  'EQIX',
  'EQR',
  'ESS',
  'EL',
  'EVRG',
  'ES',
  'RE',
  'EXC',
  'EXPE',
  'EXPD',
  'EXR',
  'XOM',
  'FFIV',
  'FB',
  'FAST',
  'FRT',
  'FDX',
  'FIS',
  'FITB',
  'FE',
  'FRC',
  'FISV',
  'FLT',
  'FLIR',
  'FLS',
  'FMC',
  'F',
  'FTNT',
  'FTV',
  'FBHS',
  'FOXA',
  'FOX',
  'BEN',
  'FCX',
  'GPS',
  'GRMN',
  'IT',
  'GD',
  'GE',
  'GIS',
  'GM',
  'GPC',
  'GILD',
  'GL',
  'GPN',
  'GS',
  'GWW',
  'HAL',
  'HBI',
  'HIG',
  'HAS',
  'HCA',
  'PEAK',
  'HSIC',
  'HSY',
  'HES',
  'HPE',
  'HLT',
  'HFC',
  'HOLX',
  'HD',
  'HON',
  'HRL',
  'HST',
  'HWM',
  'HPQ',
  'HUM',
  'HBAN',
  'HII',
  'IEX',
  'IDXX',
  'INFO',
  'ITW',
  'ILMN',
  'INCY',
  'IR',
  'INTC',
  'ICE',
  'IBM',
  'IP',
  'IPG',
  'IFF',
  'INTU',
  'ISRG',
  'IVZ',
  'IPGP',
  'IQV',
  'IRM',
  'JKHY',
  'J',
  'JBHT',
  'SJM',
  'JNJ',
  'JCI',
  'JPM',
  'JNPR',
  'KSU',
  'K',
  'KEY',
  'KEYS',
  'KMB',
  'KIM',
  'KMI',
  'KLAC',
  'KSS',
  'K',
  'KR',
  'LB',
  'LHX',
  'LH',
  'LRCX',
  'LW',
  'LVS',
  'LEG',
  'LDOS',
  'LEN',
  'LLY',
  'LNC',
  'LIN',
  'LYV',
  'LKQ',
  'LMT',
  'L',
  'LOW',
  'LYB',
  'MTB',
  'MRO',
  'MPC',
  'MKTX',
  'MAR',
  'MMC',
  'MLM',
  'MAS',
  'MA',
  'MKC',
  'MXIM',
  'MCD',
  'MCK',
  'MDT',
  'MRK',
  'MET',
  'MTD',
  'MGM',
  'MCHP',
  'MU',
  'MSFT',
  'MAA',
  'MHK',
  'TAP',
  'MDLZ',
  'MNST',
  'MCO',
  'MS',
  'MOS',
  'MSI',
  'MSCI',
  'MYL',
  'NDAQ',
  'NOV',
  'NTAP',
  'NFLX',
  'NWL',
  'NEM',
  'NWSA',
  'NWS',
  'NEE',
  'NLSN',
  'NKE',
  'NI',
  'NSC',
  'NTRS',
  'NOC',
  'NLOK',
  'NCLH',
  'NRG',
  'NUE',
  'NVDA',
  'NVR',
  'ORLY',
  'OXY',
  'ODFL',
  'OMC',
  'OKE',
  'ORCL',
  'PCAR',
  'PKG',
  'PH',
  'PAYX',
  'PAYC',
  'PYPL',
  'PNR',
  'PBCT',
  'PEP',
  'PKI',
  'PRGO',
  'PFE',
  'PM',
  'PSX',
  'PNW',
  'PXD',
  'PNC',
  'POOL',
  'PPG',
  'PPL',
  'PFG',
  'PG',
  'PGR',
  'PLD',
  'PRU',
  'PTC',
  'PEG',
  'PSA',
  'PHM',
  'PVH',
  'QRVO',
  'PWR',
  'QCOM',
  'DGX',
  'RL',
  'RJF',
  'RTX',
  'O',
  'REG',
  'REGN',
  'RF',
  'RSG',
  'RMD',
  'RHI',
  'ROK',
  'ROL',
  'ROP',
  'ROST',
  'RCL',
  'SPGI',
  'CRM',
  'SBAC',
  'SLB',
  'STX',
  'SEE',
  'SRE',
  'NOW',
  'SHW',
  'SPG',
  'SWKS',
  'SLG',
  'SNA',
  'SO',
  'LUV',
  'SWK',
  'SBUX',
  'STT',
  'STE',
  'SYK',
  'SIVB',
  'SYF',
  'SNPS',
  'SYY',
  'TMUS',
  'TROW',
  'TTWO',
  'TPR',
  'TGT',
  'TEL',
  'FTI',
  'TXN',
  'TXT',
  'TMO',
  'TIF',
  'TWTR',
  'TJX',
  'TSCO',
  'TDG',
  'TRV',
  'TRMB',
  'TFC',
  'TWLO',
  'TSN',
  'UDR',
  'ULTA',
  'USB',
  'UAA',
  'UA',
  'UNP',
  'UAL',
  'UNH',
  'UPS',
  'URI',
  'UHS',
  'UNM',
  'VLO',
  'VAR',
  'VTR',
  'VRSN',
  'VRSK',
  'VZ',
  'VRTX',
  'VFC',
  'VIAC',
  'V',
  'VNO',
  'VMC',
  'WRB',
  'WAB',
  'WMT',
  'WBA',
  'DIS',
  'WM',
  'WAT',
  'WEC',
  'WFC',
  'WELL',
  'WST',
  'WDC',
  'WU',
  'WRK',
  'WY',
  'WHR',
  'WMB',
  'WLTW',
  'WYNN',
  'XEL',
  'XRX',
  'XLNX',
  'XYL',
  'YUM',
  'ZBRA',
  'ZBH',
  'ZION',
  'ZTS',
];
